module.exports = __webpack_public_path__ + "img/FR15818.9185b65d.png";